<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>客户进件记录</span>
        <span>客户进件记录</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="header">
      <div class="item">
        <van-search
          v-model="params.layerName"
          placeholder="请输入企业名称"
          show-action
          @search="onSearch"
          ><template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div>
          <span>申请列表</span><span>总数{{ dataList.length }}条</span>
        </div>
        <!-- <div>
          <span @click="toPage('layerCodeForm')">新增夹层码</span>
        </div> -->
      </div>
      <div class="item-box">
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div>
            <span>企业名称</span><span>{{ item.companyName }}</span>
          </div>
          <div>
            <span>申请状态</span><span>{{ item.state }}</span>
          </div>
          <div>
            <span>授信金额</span> <span>{{ item.creditAmount }}</span>
          </div>
          <div>
            <span>提款金额</span><span>{{ item.useAmount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XcExhibitionSystemApplyRecord",

  data() {
    return {
      params: {
        layerName: "",
        size: 10,
        page: 0,
        sort: "id,desc",
      },
      dataList: [],
    };
  },

  mounted() {},

  methods: { onSearch() {} },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/myCustomer/module/applyRecord/index.vue